import styled from "styled-components";

export const ProfileListWrapper = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }

  // 태블릿 환경 (768px 이상, 세로) 설정
  @media (min-width: 768px) and (orientation: portrait) {
    overflow: auto;
    height: calc(100vh - 300px);
  }
`;

export const ProfileList = styled.ul`
  display: flex;
  align-items: center;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    width: 100%;
    height: auto;
    flex-direction: column;
  }

  // 모바일 가로 모드 대응
  @media (orientation: landscape) {
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
    width: 100%;
    height: 100vh;
    min-height: 0;
    gap: 16px;
  }
`;
